import styled from "styled-components"

const ContentBlock = styled.div`
  padding: var(--spacingContent);
`

export default ContentBlock
